module.exports = __webpack_public_path__ + "img/icon-expand-menu.b4f3b9a9.svg";